import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mbm-message',
  imports: [TranslateModule],
  templateUrl: './mbm-message.component.html',
  styleUrl: './mbm-message.component.scss',
})
export class MbmMessageComponent {
  readonly messageKey = input.required<string>();
}
